import BaseService from './BaseService';
import entities from 'src/config/entities';

class ApplicantsService extends BaseService{

  constructor() {
    super({ entity: entities.APPLICANTS });
  }

  async verify(id, data) {
    try {
      let res = await this.instance.put(`/${id}/verify`, data)
      return res.data
    } catch (e) {
      this._handleError({ translationKey: 'applicants.messages.verifyError', error: e });
      throw e;
    }
  }

  async resend(id, data) {
    try {
      let res = await this.instance.post(`/${id}/resend`, data)
      return res.data
    } catch (e) {
      this._handleError({ translationKey: 'applicants.messages.verifyError', error: e });
      throw e;
    }
  }


}

export default new ApplicantsService();
